import { assign, setup } from "xstate";

export const v1 = setup({
  types: {
    context: {} as { LEGAL_STEP: string },
    events: {} as
      | { type: "Renvoi" }
      | { type: "Abandon" }
      | { type: "Attente > 15j" }
      | { type: "Attente > 30J" }
      | { type: "Accord trouvé" }
      | { type: "Défaite appel" }
      | { type: "Groupe validé" }
      | { type: "Paiement reçu" }
      | { type: "Victoire appel" }
      | { type: "Relance envoyé" }
      | { type: "Défaite procès" }
      | { type: "Paiement envoyé" }
      | { type: "Relance envoyée" }
      | { type: "Date communiquée" }
      | { type: "Dossier confirmé" }
      | { type: "Dossier abandonné" }
      | { type: "Exécution forcée" }
      | { type: "Préjudice établi" }
      | { type: "Réponse favorable" }
      | { type: "Envoi au Médiateur" }
      | { type: "Envoi de la relance" }
      | { type: "Victoire du procès" }
      | { type: "Assignation validée" }
      | { type: "Décision signifiée" }
      | { type: "Formulaire A envoyé" }
      | { type: "Ouverture du dossier" }
      | { type: "Procédure classique" }
      | { type: "Saisie de l'huissier" }
      | { type: "Validation du groupe" }
      | { type: "Conclusion vérifiée" }
      | { type: "Email passager obtenu" }
      | { type: "Appel par la compagnie" }
      | { type: "Cession(s) envoyée(s)" }
      | { type: "Procédure bref délai" }
      | { type: "Signature du protocole" }
      | { type: "Réception du protocole" }
      | { type: "Abandon de la procédure" }
      | { type: "Mise en Demeure envoyée" }
      | { type: "Réponse de la compagnie" }
      | { type: "Éligibilité vérifiée" }
      | { type: "Absence de paiement > 40j" }
      | { type: "Absence de réponse > 15j" }
      | { type: "Non signature du protocole" }
      | { type: "Abandon – Absence d'email" }
      | { type: "Retour au choix de Tribunal" }
      | { type: "Retour au choix du tribunal" }
      | { type: "Avis favorable du Médiateur" }
      | { type: "Pas de préjudice entreprise" }
      | { type: "Absence de réponse favorable" }
      | { type: "Cessions de créances reçues" }
      | { type: "La compagnie accepte de payer" }
      | { type: "Préjudice entreprise établi" }
      | { type: "Date d'audience sélectionnée" }
      | { type: "Désistement d'instance simple" }
      | { type: "La compagnie n'a pas fait appel" }
      | { type: "Procédure bref délai refusée" }
      | { type: "Signature entreprise effectuée" }
      | { type: "Document passagers receptionnés" }
      | { type: "Dossier signé électroniquement" }
      | { type: "Formulaire B envoyé au tribunal" }
      | { type: "Procédure bref délai accordée" }
      | { type: "Retour au choix de la procédure" }
      | { type: "Absence d'accord avant l'audience" }
      | { type: "Audience de plaidoirie effectuée" }
      | { type: "Flux de contact direct enclenché" }
      | { type: "Non réception du protocole > 15j" }
      | { type: "Tribunal compétent sélectionné" }
      | { type: "Délai signature entrepris expiré" }
      | { type: "Envoi du protocole à la compagnie" }
      | { type: "Assignation transmise à l'huissier" }
      | { type: "Cession(s) envoyée(s) manuellement" }
      | { type: "Désistement d'instance et d'action" }
      | { type: "Email passager demandé à l'agence" }
      | { type: "Dossier enrôlé auprès du tribunal" }
      | { type: "Formulaire C envoyé par le tribunal" }
      | { type: "Le médiateur s'est saisi du dossier" }
      | { type: "Cession agence envers Upclaim signée" }
      | { type: "Envoi du dossier à l'agent de voyage" }
      | { type: "Protocole non signé par la compagnie" }
      | { type: "Retour au choix de la date d'audience" }
      | { type: "Email passager demandé à la société" }
      | { type: "Signature du protocole par la compagnie" }
      | { type: "1ère tentative de conciliation envoyée" }
      | { type: "Règlement des petits litiges européens" }
      | { type: "Cession passagers et entreprise envoyées" }
      | { type: "Rejet de l'avis par la compagnie aérienne" }
      | { type: "Absence de réponse > 30j (Avec plaidoirie)" }
      | { type: "Absence de réponse > 30j (Sans plaidoirie)" }
      | { type: "Droit de réponse exercé (Avec plaidoirie)" }
      | { type: "Droit de réponse exercé (Sans plaidoirie)" }
      | { type: "Formulaire prêt pour envoi avec plaidoirie" }
      | { type: "Formulaire prêt pour envoi sans plaidoirie" }
      | { type: "Formulaire B reçu (demande complémentaire)" }
      | { type: "Le médiateur rejette le traitement du dossier" }
      | { type: "Accord transactionnel homologué par le tribunal" }
      | { type: "La compagnie annonce suivre l'avis du médiateur" }
      | { type: "La réponse de la compagnie ne nous convient pas" }
      | { type: "Nous avons apporté une réponse à la compagnie" }
      | { type: "Protocole transactionnel envoyé à la compagnie" }
      | { type: "Avis négatif : Rejet de l'avis par le médiateur" }
      | { type: "La réponse de la compagnie mérite approfondissement" }
      | { type: "Désistement médiateur suite à accord avec la compagnie" }
      | { type: "L'huissier a remis l'assignation à la compagnie aérienne" }
      | { type: "Abandon car nous sommes d'accord avec les arguments de la compagnie" }
      | { type: "Dossier transmis aux avocats : Leur réponse ne nous satisfaisait pas" }
      | { type: "Dossier transmis aux avocats : Car absence de réponse à notre mise en demeure" }
      | { type: "Partie passager validée : Envoi pour confirmation des préjudices à l'entreprise" }
      | { type: "Absence d'avis après 6 mois" }
      | { type: "La compagnie n'a pas répondu" },
  },
  actions: {
    "Mise en demeure envoyée": ({ context: _ctx, event: _ev }) => {
      // Add your action code here
      // ...
    },
    "Protocole transactionnel généré": ({ context: _ctx, event: _ev }) => {
      // Add your action code here
      // ...
    },
    "Relance après délibéré ": ({ context: _ctx, event: _ev }) => {
      // Add your action code here
      // ...
    },
    Assignation: ({ context: _ctx, event: _ev }) => {
      // Add your action code here
      // ...
    },
    "Rédaction des conclusions": ({ context: _ctx, event: _ev }) => {
      // Add your action code here
      // ...
    },
    "Envoi du jeu de conclusion": ({ context: _ctx, event: _ev }) => {
      // Add your action code here
      // ...
    },
    'Mail au greffe du TC pour solliciter une procédure "Bref délai"': ({ context: _ctx, event: _ev }) => {
      // Add your action code here
      // ...
    },
    "Rédaction de la requête": ({ context: _ctx, event: _ev }) => {
      // Add your action code here
      // ...
    },
    "Remplissage formulaire A": ({ context: _ctx, event: _ev }) => {
      // Add your action code here
      // ...
    },
    'Envoi de l\'assignation + ordonnance "bref délai"': ({ context: _ctx, event: _ev }) => {
      // Add your action code here
      // ...
    },
    "Requête envoyée ": ({ context: _ctx, event: _ev }) => {
      // Add your action code here
      // ...
    },
    "Désistement d'instance": ({ context: _ctx, event: _ev }) => {
      // Add your action code here
      // ...
    },
  },
}).createMachine({
  context: {
    LEGAL_STEP: "UPCLAIM",
  },
  id: "Indemnisation",
  initial: "Validation dossier",
  states: {
    "Validation dossier": {
      initial: "État initial",
      on: {
        Abandon: {
          target: "Abandon",
          meta: {
            EVENT_NAME: "CLAIM_VALIDATION.CLOSE_CLAIM",
          },
        },
      },
      entry: assign({ LEGAL_STEP: "CLAIM_VALIDATION" }),
      meta: {
        "@statelyai.color": "green",
      },
      states: {
        "État initial": {
          on: {
            "Ouverture du dossier": {
              target: "Attente vérification éligibilité",
              meta: {
                EVENT_NAME: "CLAIM_VALIDATION.CLAIM_CREATED",
              },
            },
          },
          meta: {
            STATE_NAME: "INITIAL_STATE",
          },
        },
        "Attente vérification éligibilité": {
          on: {
            "Éligibilité vérifiée": {
              target: "Choix du mode de contact",
              description: "Cadre juridique vérifié. Nous sommes en capacité de traiter le dossier.",
              meta: {
                EVENT_NAME: "CLAIM_VALIDATION.CLAIM_ELIGIBILITY_CONFIRMED",
              },
            },
          },
          meta: {
            STATE_NAME: "CLAIM_VALIDATION.WAIT_FOR_ELIGIBILITY_CHECK",
            EXPECTED_DURATION_IN_DAYS: 120,
            MAX_DAYS: 120,
            "@statelyai.color": "purple",
          },
        },
        "Choix du mode de contact": {
          on: {
            "Flux de contact direct enclenché": {
              target: "Attente confirmation électronique passager",
              description: "Email addressé à chaque passager, en direct.",
              meta: {
                EVENT_NAME: "CLAIM_VALIDATION.DIRECT_PASSENGERS_CONTACT_CHOOSEN",
              },
            },
            "Envoi du dossier à l'agent de voyage": {
              target: "Attente confirmation agent",
              description: "(Ou l'account manager)",
              meta: {
                EVENT_NAME: "CLAIM_VALIDATION.MANUAL_PASSENGERS_CONTACT_CHOOSEN",
              },
            },
            "Cession(s) envoyée(s) manuellement": {
              target: "Attente signature cession(s) de créance(s)",
              description: "À l'agent ou l'account manager - sans préjudice",
              meta: {
                EVENT_NAME: "CLAIM_VALIDATION.DEBT_CONTRACT_SENT_MANUALLY",
              },
            },
            "Email passager demandé à l'agence": {
              target: "Attente email passager par l'agence",
              meta: {
                EVENT_NAME: "CLAIM_VALIDATION.PAX_EMAIL_ASKED_TO_TRAVEL_AGENCY",
              },
            },
            "Email passager demandé à la société": {
              target: "Attente email passager par le reponsable voyage",
              meta: {
                EVENT_NAME: "CLAIM_VALIDATION.PAX_EMAIL_ASKED_TO_ENTERPRISE",
              },
            },
          },
          meta: {
            STATE_NAME: "CLAIM_VALIDATION.CHOICE_OF_CONTACT_MODE",
            "@statelyai.color": "purple",
          },
        },
        "Attente confirmation électronique passager": {
          on: {
            "Dossier signé électroniquement": {
              target: "Attente signature Agence",
              description: "Chaque passager à signé électroniquement le document de cession de créance.",
              meta: {
                EVENT_NAME: "CLAIM_VALIDATION.ALL_PASSENGERS_HAVE_SIGNED",
              },
            },
            "Partie passager validée : Envoi pour confirmation des préjudices à l'entreprise": {
              target: "Attente préjudices entreprise",
              description:
                "Chaque passager à signé électroniquement le document de cession de créance.\n\n\nEn parralèle, nous attendons la confirmation des préjudices, pour la partie entreprise.",
              meta: {
                EVENT_NAME: "CLAIM_VALIDATION.ALL_PASSENGERS_HAVE_SIGNED_WITH_ENTERPRISE_LOSS",
              },
            },
          },
          description:
            "Email addressé à chaque voyageur afin d'enclencher la procédure d'indemnisation.\n\nL'ajout des frais supplémentaires et signature électronique s'effectuent ici.",
          meta: {
            STATE_NAME: "CLAIM_VALIDATION.WAIT_FOR_PASSENGER_YOUSIGN_SIGNATURE",
            MAX_DAYS: 50,
            "@statelyai.color": "blue",
          },
        },
        "Attente confirmation agent": {
          on: {
            "Dossier confirmé": {
              target: "Établissement des préjudices",
              description: "Vu avec l'agent de voyage",
              meta: {
                EVENT_NAME: "CLAIM_VALIDATION.AGENT_FEEDBACK_COLLECTED",
              },
            },
          },
          meta: {
            STATE_NAME: "CLAIM_VALIDATION.WAIT_FOR_AGENT_FEEDBACK",
            EXPECTED_DURATION_IN_DAYS: 30,
          },
        },
        "Attente signature cession(s) de créance(s)": {
          on: {
            "Document passagers receptionnés": {
              target: "Attente signature Agence",
              description:
                "Le document de cession de créance est nécessairement présent pour débuter le dossier d'indemnisation.",
              meta: {
                EVENT_NAME: "CLAIM_VALIDATION.PASSENGERS_DEBT_SIGNED",
              },
            },
          },
          description: "Attente de la signature cession voyageur.",
          meta: {
            STATE_NAME: "CLAIM_VALIDATION.WAIT_FOR_RECEIVABLE_CONTRACT_SIGNATURES",
            EXPECTED_DURATION_IN_DAYS: 45,
            MAX_DAYS: 50,
          },
        },
        "Attente email passager par l'agence": {
          on: {
            "Email passager obtenu": {
              target: "Choix du mode de contact",
              meta: {
                EVENT_NAME: "CLAIM_VALIDATION.PAX_EMAIL_RECEIVED_FROM_TRAVEL_AGENCY",
              },
            },
            "Abandon – Absence d'email": {
              target: "#Indemnisation.Abandon",
              meta: {
                EVENT_NAME: "CLAIM_VALIDATION.NO_PAX_EMAIL_RECEIVED_FROM_TRAVEL_AGENCY",
              },
            },
          },
          meta: {
            STATE_NAME: "CLAIM_VALIDATION.WAIT_FOR_PAX_EMAIL_FROM_TRAVEL_AGENCY",
            EXPECTED_DURATION_IN_DAYS: 30,
          },
        },
        "Attente email passager par le reponsable voyage": {
          on: {
            "Email passager obtenu": {
              target: "Choix du mode de contact",
              meta: {
                EVENT_NAME: "CLAIM_VALIDATION.PAX_EMAIL_RECEIVED_FROM_ENTERPRISE",
              },
            },
            "Abandon – Absence d'email": {
              target: "#Indemnisation.Abandon",
              meta: {
                EVENT_NAME: "CLAIM_VALIDATION.NO_PAX_EMAIL_RECEIVED_FROM_ENTERPRISE",
              },
            },
          },
          meta: {
            STATE_NAME: "CLAIM_VALIDATION.WAIT_FOR_PAX_EMAIL_FROM_ENTERPRISE",
            EXPECTED_DURATION_IN_DAYS: 30,
          },
        },
        "Attente signature Agence": {
          on: {
            "Cession agence envers Upclaim signée": {
              target: "#Indemnisation.Amiable.Attente envoi 1er email",
              description:
                "Le dossier est prêt.\n\nNous allons lancer la demande d'indemnisation auprès de la compagnie aérienne d'ici 48h.",
              meta: {
                EVENT_NAME: "CLAIM_VALIDATION.DEBT_SIGNED",
              },
            },
          },
          description: "Dernière confirmation avant le lancement du dossier auprès de la compagnie aérienne.",
          meta: {
            STATE_NAME: "CLAIM_VALIDATION.WAIT_FOR_RECEIVABLE_TRAVEL_AGENCY",
            EXPECTED_DURATION_IN_DAYS: 7,
            "@statelyai.color": "blue",
          },
        },
        "Attente préjudices entreprise": {
          on: {
            "Préjudice entreprise établi": {
              target: "Attente signature entreprise",
              description: "Des dépenses ont eu lieu, il faut faire signer l'entreprise.",
              meta: {
                EVENT_NAME: "CLAIM_VALIDATION.ENTEPRISE_EXPENSES_COLLECTED",
              },
            },
            "Pas de préjudice entreprise": {
              target: "Attente signature Agence",
              description:
                "L'entreprise n'a pas communiqué de préjudice sur ce dossier.\n\nIl n'y a donc pas besoin de la faire signer.",
              meta: {
                EVENT_NAME: "CLAIM_VALIDATION.ENTEPRISE_EXPENSES_COLLECTED_EMPTY",
              },
            },
          },
          description: "L'entreprise a 15 jours pour nous confirmer ses préjudices.",
          meta: {
            STATE_NAME: "CLAIM_VALIDATION.WAIT_FOR_ENTERPRISE_ADDITIONAL_LOSS",
            MAX_DAYS: 21,
            "@statelyai.color": "blue",
          },
        },
        "Établissement des préjudices": {
          on: {
            "Préjudice établi": {
              target: "Création des documents à envoyer",
              meta: {
                EVENT_NAME: "CLAIM_VALIDATION.ADDITIONAL_LOSS_COLLECTED",
              },
            },
          },
          meta: {
            STATE_NAME: "CLAIM_VALIDATION.WAIT_FOR_ADDITIONAL_LOSS_FEEDBACK",
            EXPECTED_DURATION_IN_DAYS: 21,
            MAX_DAYS: 45,
          },
        },
        "Attente signature entreprise": {
          on: {
            "Signature entreprise effectuée": {
              target: "Attente signature Agence",
              meta: {
                EVENT_NAME: "CLAIM_VALIDATION.ENTERPRISE_HAS_SIGNED",
              },
            },
            "Délai signature entrepris expiré": {
              target: "Attente signature Agence",
              meta: {
                EVENT_NAME: "CLAIM_VALIDATION.ENTERPRISE_SIGNATURE_EXPIRED",
              },
            },
          },
          description:
            "Nous laissons 30 jours ouvrés à l'entreprise pour signer.\n\nElle recevera des relances régulièrement.",
          meta: {
            STATE_NAME: "CLAIM_VALIDATION.WAIT_FOR_ENTREPRISE_SIGNATURE",
            MAX_DAYS: 30,
            "@statelyai.color": "blue",
          },
        },
        "Création des documents à envoyer": {
          on: {
            "Cession(s) envoyée(s)": {
              target: "Attente signature cession(s) de créance(s)",
              description: "Pour signature manuscrite",
              meta: {
                EVENT_NAME: "CLAIM_VALIDATION.DEBT_CONTRACT_SENT",
              },
            },
            "Cession passagers et entreprise envoyées": {
              target: "Attente signature Entreprise et Voyageur(s)",
              description: "Envoyé manuellement à l'account manager, qui s'occupe de cette entreprise.",
              meta: {
                EVENT_NAME: "CLAIM_VALIDATION.DEBT_CONTRACT_SENT_B2C_AND_B2B",
              },
            },
          },
          description: "Documents de cession de créance à créer.",
          meta: {
            EXPECTED_DURATION_IN_DAYS: 2,
            STATE_NAME: "CLAIM_VALIDATION.WAIT_FOR_DOCUMENTS_CREATION",
          },
        },
        "Attente signature Entreprise et Voyageur(s)": {
          on: {
            "Cessions de créances reçues": {
              target: "Attente signature Agence",
              description:
                "Entreprise & Passager.\n\n\nLe document de cession de créance VOYAGEUR est nécessairement présent pour débuter le dossier d'indemnisation.",
              meta: {
                EVENT_NAME: "CLAIM_VALIDATION.PASSENGERS_AND_ENTERPRISE_DEBT_SIGNED",
              },
            },
          },
          meta: {
            STATE_NAME: "CLAIM_VALIDATION.WAIT_FOR_RECEIVABLE_CONTRACT_SIGNATURES_B2C_AND_B2B",
            MAX_DAYS: 50,
          },
        },
      },
    },
    Abandon: {
      type: "final",
      entry: assign({ LEGAL_STEP: "CANCELLED" }),
      description: "Clotûre du dossier, avant validation",
      meta: {
        STATE_NAME: "CANCELLED",
      },
    },
    Amiable: {
      initial: "Attente envoi 1er email",
      on: {
        Abandon: {
          target: "Dossier perdu",
          meta: {
            EVENT_NAME: "UPCLAIM.ABORTION",
          },
        },
      },
      entry: assign({ LEGAL_STEP: "UPCLAIM" }),
      meta: {
        EXPECTED_DURATION_IN_DAYS: 15,
        "@statelyai.color": "blue",
      },
      states: {
        "Attente envoi 1er email": {
          on: {
            "1ère tentative de conciliation envoyée": {
              target: "En cours",
              description:
                "Nous avons adressé la requête d'indemnisation à la compagnie aérienne. Nous lui laissons 15 jours pour répondre.",
              meta: {
                EVENT_NAME: "UPCLAIM.FIRST_EMAIL_SENT",
              },
            },
          },
          meta: {
            EXPECTED_DURATION_IN_DAYS: 3,
            STATE_NAME: "UPCLAIM.WAIT_FOR_1ST_EMAIL_SEND",
          },
        },
        "En cours": {
          initial: "Attente de réponse de la compagnie",
          states: {
            "Attente de réponse de la compagnie": {
              on: {
                "La réponse de la compagnie ne nous convient pas": {
                  target: "Attente envoi Mise en Demeure",
                  description:
                    "Nous ne sommes pas d'accord avec la réponse de la compagnie aérienne. Nous allons lui envoyer une Mise en Demeure.",
                  meta: {
                    EVENT_NAME: "UPCLAIM.DISAGREE_AIRLINE_REPLY",
                  },
                },
                "La réponse de la compagnie mérite approfondissement": {
                  target: "Attente de réponse par nos juristes",
                  meta: {
                    EVENT_NAME: "UPCLAIM.AIRLINE_REPLY_DESERVES_FURTHER_STUDY",
                    EXPECTED_DURATION_IN_DAYS: 2,
                  },
                },
                "La compagnie accepte de payer": {
                  target: "#Indemnisation.La compagnie accepte de payer.Procédure de paiement amiable",
                  meta: {
                    EVENT_NAME: "UPCLAIM.AIRLINE_AGREES_TO_PAY",
                  },
                },
                "Absence de réponse > 15j": {
                  target: "Attente envoi Mise en Demeure",
                  description:
                    "La compagnie n'a pas répondu à notre tentative de conciliation amiable.\nNous allons lui envoyer une Mise en Demeure.",
                  meta: {
                    EVENT_NAME: "UPCLAIM.AIRLINE_REPLY_DELAY_EXCEDEED",
                  },
                },
              },
              meta: {
                STATE_NAME: "UPCLAIM.WAIT_FOR_AIRLINE_REPLY",
                EXPECTED_DURATION_IN_DAYS: 15,
              },
            },
            "Attente envoi Mise en Demeure": {
              on: {
                "Mise en Demeure envoyée": {
                  target: "#Indemnisation.Pré-contentieux.Attente de réponse à notre Mise en Demeure",
                  description:
                    "La compagnie a été mise en demeure de payer. Elle a 30 jours pour nous répondre positivement, ou nous saisirons nos avocats.",
                  meta: {
                    EVENT_NAME: "UPCLAIM.MED_SENT",
                  },
                },
              },
              meta: {
                STATE_NAME: "UPCLAIM.WAIT_SENDS_MED",
              },
            },
            "Attente de réponse par nos juristes": {
              on: {
                "Nous avons apporté une réponse à la compagnie": {
                  target: "Attente de réponse de la compagnie",
                  meta: {
                    EVENT_NAME: "UPCLAIM.OUTBOUND_REPLY_SENT",
                  },
                },
              },
              meta: {
                STATE_NAME: "UPCLAIM.WAIT_FOR_UPCLAIM_REPLY",
                EXPECTED_DURATION_IN_DAYS: 4,
              },
            },
          },
        },
      },
    },
    "Pré-contentieux": {
      initial: "Attente de réponse à notre Mise en Demeure",
      on: {
        Abandon: {
          target: "Dossier perdu",
          meta: {
            EVENT_NAME: "CONCILIATION.ABORTION",
          },
        },
      },
      entry: [
        {
          type: "Mise en demeure envoyée",
        },
        assign({ LEGAL_STEP: "CONCILIATION" }),
      ],
      meta: {
        EXPECTED_DURATION_IN_DAYS: 30,
        "@statelyai.color": "yellow",
      },
      states: {
        "Attente de réponse à notre Mise en Demeure": {
          on: {
            "Dossier transmis aux avocats : Leur réponse ne nous satisfaisait pas": {
              target: "#Indemnisation.Contentieux",
              description:
                "La compagnie aérienne refuse de payer et nous ne sommes pas d'accord avec leur réponse. Nous avons saisi notre cabinet d'avocats.",
              meta: {
                EVENT_NAME: "CONCILIATION.DISAGREE_AIRLINE_REPLY",
              },
            },
            "La réponse de la compagnie mérite approfondissement": {
              target: "Attente rédaction de réponse (Suite à Mise en Demeure)",
              meta: {
                EXPECTED_DURATION_IN_DAYS: 7,
                EVENT_NAME: "CONCILIATION.AIRLINE_REPLY_DESERVES_FURTHER_STUDY",
              },
            },
            "La compagnie accepte de payer": {
              target: "#Indemnisation.La compagnie accepte de payer.Procédure de paiement pré-contentieuse",
              meta: {
                EVENT_NAME: "CONCILIATION.AIRLINE_AGREES_TO_PAY",
              },
            },
            "Dossier transmis aux avocats : Car absence de réponse à notre mise en demeure": {
              target: "#Indemnisation.Contentieux",
              description:
                "Suite à l'absence de réponse à notre Mise en Demeure, nous avons saisi notre cabinet d'Avocats.",
              meta: {
                EXPECTED_DURATION_IN_DAYS: 15,
                EVENT_NAME: "CONCILIATION.AIRLINE_REPLY_DELAY_EXCEDEED",
              },
            },
          },
          meta: {
            STATE_NAME: "CONCILIATION.WAIT_FOR_AIRLINE_REPLY",
            EXPECTED_DURATION_IN_DAYS: 28,
          },
        },
        "Attente rédaction de réponse (Suite à Mise en Demeure)": {
          on: {
            "Nous avons apporté une réponse à la compagnie": {
              target: "Attente de réponse à notre Mise en Demeure",
              meta: {
                EVENT_NAME: "CONCILIATION.OUTBOUND_REPLY_SENT",
              },
            },
          },
          meta: {
            EXPECTED_DURATION_IN_DAYS: 7,
            STATE_NAME: "CONCILIATION.WAIT_FOR_AIRLINE_REPLY",
          },
        },
      },
    },
    "La compagnie accepte de payer": {
      initial: "Procédure de paiement amiable",
      entry: assign({ LEGAL_STEP: "WAITING_FOR_MONEY" }),
      meta: {
        "@statelyai.color": "purple",
      },
      states: {
        "Procédure de paiement amiable": {
          initial: "Attente du paiement amiable",
          meta: {
            EXPECTED_DURATION_IN_DAYS: "30",
          },
          states: {
            "Attente du paiement amiable": {
              on: {
                "Paiement reçu": {
                  target: "#Indemnisation.La compagnie accepte de payer.Claim gagnée",
                  meta: {
                    EVENT_NAME: "WAITING_FOR_MONEY.UPCLAIM_PAYMENT_RECEIVED",
                  },
                },
                "Attente > 15j": {
                  target: "Procédure de relance amiable",
                  meta: {
                    EVENT_NAME: "WAITING_FOR_MONEY.UPCLAIM_PAYMENT_NOT_RECEIVED",
                  },
                },
              },
              meta: {
                EXPECTED_DURATION_IN_DAYS: 20,
                STATE_NAME: "WAITING_FOR_MONEY.UPCLAIM_WAIT_FOR_PAYMENT",
              },
            },
            "Procédure de relance amiable": {
              initial: "Rédaction de la relance",
              states: {
                "Rédaction de la relance": {
                  on: {
                    "Envoi de la relance": {
                      target: "Attente de réponse",
                      meta: {
                        EVENT_NAME: "WAITING_FOR_MONEY.UPCLAIM_FOLLOW_UP",
                      },
                    },
                  },
                  meta: {
                    EXPECTED_DURATION_IN_DAYS: 3,
                    STATE_NAME: "WAITING_FOR_MONEY.UPCLAIM_WAIT_FOR_FOLLOW_UP_REDACTION",
                  },
                },
                "Attente de réponse": {
                  on: {
                    "Réponse favorable": {
                      target:
                        "#Indemnisation.La compagnie accepte de payer.Procédure de paiement amiable.Attente reception des fonds sur compte",
                      meta: {
                        EVENT_NAME: "WAITING_FOR_MONEY.UPCLAIM_FOLLOW_UP_AIRLINE_AGREEMENT",
                      },
                    },
                    "Absence de réponse favorable": {
                      target: "#Indemnisation.Pré-contentieux",
                      meta: {
                        EVENT_NAME: "WAITING_FOR_MONEY.UPCLAIM_NO_AGREEMENT_AFTER_FOLLOW_UP",
                      },
                    },
                  },
                  meta: {
                    EXPECTED_DURATION_IN_DAYS: "15",
                    STATE_NAME: "WAITING_FOR_MONEY.UPCLAIM_WAIT_FOR_PAYMENT_FOLLOW_UP_REPLY",
                  },
                },
              },
            },
            "Attente reception des fonds sur compte": {
              on: {
                "Paiement reçu": {
                  target: "#Indemnisation.La compagnie accepte de payer.Claim gagnée",
                  meta: {
                    EVENT_NAME: "WAITING_FOR_MONEY.UPCLAIM_PAYMENT_RECEIVED_AFTER_FOLLOW_UP",
                  },
                },
                "Absence de paiement > 40j": {
                  target: "#Indemnisation.Pré-contentieux",
                  meta: {
                    EVENT_NAME: "WAITING_FOR_MONEY.UPCLAIM_PAYMENT_NOT_RECEIVED_AFTER_FOLLOW_UP",
                  },
                },
              },
              meta: {
                EXPECTED_DURATION_IN_DAYS: 30,
                STATE_NAME: "WAITING_FOR_MONEY.UPCLAIM_WAIT_FOR_PAYMENT_AFTER_FOLLOW_UP",
              },
            },
          },
        },
        "Claim gagnée": {
          on: {
            "Paiement envoyé": {
              target: "Paiement effectué",
              meta: {
                EVENT_NAME: "PAYMENT_SENT",
              },
            },
          },
          description:
            "Le virement est en cours de traitement chez nous. Vous serez notifié lorsque l'argent sera disponible.",
          meta: {
            STATE_NAME: "MONEY_RECEIVED",
            "@statelyai.color": "green",
          },
        },
        "Procédure de paiement pré-contentieuse": {
          initial: "Procédure de paiement pré-contentieux avant assignation",
          states: {
            "Procédure de paiement pré-contentieux avant assignation": {
              initial: "Attente de rédaction du protocole transactionnel",
              on: {
                "Protocole transactionnel envoyé à la compagnie": {
                  target:
                    "#Indemnisation.La compagnie accepte de payer.Procédure de paiement pré-contentieuse.Procédure de paiement pré-contentieux avant assignation.Attente de signature du protocole transactionnel",
                  meta: {
                    EVENT_NAME: "WAITING_FOR_MONEY.CONCILIATION_TRANSACTIONAL_PROTOCOL_SENT_TO_AIRLINE",
                  },
                  reenter: true,
                },
              },
              states: {
                "Attente de rédaction du protocole transactionnel": {
                  meta: {
                    EXPECTED_DURATION_IN_DAYS: 20,
                    STATE_NAME: "WAITING_FOR_MONEY.CONCILIATION_WAIT)FOR_TRANSACTIONAL_PROTOCOL_GENERATION",
                  },
                },
                "Attente de signature du protocole transactionnel": {
                  on: {
                    "Signature du protocole": {
                      target:
                        "#Indemnisation.La compagnie accepte de payer.Attente du paiement sur le fond CARPA",
                      actions: {
                        type: "Désistement d'instance",
                      },
                      description: "Désistement d'instance",
                      meta: {
                        EVENT_NAME: "WAITING_FOR_MONEY.CONCILIATION_TRANSACTIONAL_PROTOCOL_SIGNED_BY_AIRLINE",
                      },
                    },
                    "Non signature du protocole": {
                      target:
                        "#Indemnisation.La compagnie accepte de payer.Procédure de paiement pré-contentieuse.Procédure de relance pré-contentieux",
                      meta: {
                        EVENT_NAME:
                          "WAITING_FOR_MONEY.CONCILIATION_TRANSACTIONAL_PROTOCOL_NOT_SIGNED_BY_AIRLINE",
                      },
                    },
                  },
                  meta: {
                    EXPECTED_DURATION_IN_DAYS: "15",
                    STATE_NAME: "WAITING_FOR_MONEY.CONCILIATION_WAIT)FOR_TRANSACTIONAL_PROTOCOL_SIGNATURE",
                  },
                },
              },
            },
            "Procédure de relance pré-contentieux": {
              initial: "Rédaction de la relance sans protocole",
              states: {
                "Rédaction de la relance sans protocole": {
                  initial: "Rédaction de la relance sans protocole",
                  states: {
                    "Rédaction de la relance sans protocole": {
                      on: {
                        "Relance envoyé": {
                          target: "Attente de réponse",
                          description: "Sans protocole transactionnel",
                          meta: {
                            EVENT_NAME: "WAITING_FOR_MONEY.CONCILIATION_FOLLOW_UP_SENT_WITHOUT_PROTOCOLE",
                          },
                        },
                      },
                      meta: {
                        EXPECTED_DURATION_IN_DAYS: 15,
                        STATE_NAME: "WAITING_FOR_MONEY.CONCILIATION_WAIT_FOR_FOLLOW_UP_WITHOUT_PROTOCOLE",
                      },
                    },
                    "Attente de réponse": {
                      on: {
                        "Réception du protocole": {
                          target:
                            "#Indemnisation.La compagnie accepte de payer.Attente du paiement sur le fond CARPA",
                          meta: {
                            EVENT_NAME:
                              "WAITING_FOR_MONEY.CONCILIATION_TRANSACTIONAL_PROTOCOL_RECEIVED_AFTER_FOLLOW_UP",
                          },
                        },
                        "Non réception du protocole > 15j": {
                          target: "#Indemnisation.Contentieux",
                          meta: {
                            EVENT_NAME:
                              "WAITING_FOR_MONEY.CONCILIATION_TRANSACTIONAL_PROTOCOL_NOT_RECEIVED_AFTER_FOLLOW_UP",
                          },
                        },
                      },
                      meta: {
                        EXPECTED_DURATION_IN_DAYS: "15",
                        STATE_NAME:
                          "WAITING_FOR_MONEY.CONCILIATION_WAIT_FOR_FOLLOW_UP_REPLY_WITHOUT_TRANSACTIONAL_PROTOCOLE_REPLY",
                      },
                    },
                  },
                },
                "Rédaction de relance avec protocole transactionnel": {
                  initial: "Rédaction de la relance avec protocole transactionnel",
                  states: {
                    "Rédaction de la relance avec protocole transactionnel": {
                      on: {
                        "Relance envoyée": {
                          target: "Attente de réponse",
                          meta: {
                            EVENT_NAME:
                              "WAITING_FOR_MONEY.CONCILIATION_FOLLOW_UP_AFTER_TRANSACTIONAL_PROTOCOL",
                          },
                        },
                      },
                      meta: {
                        EXPECTED_DURATION_IN_DAYS: 4,
                        STATE_NAME:
                          "WAITING_FOR_MONEY.CONCILIATION_WAIT_FOR_TRANSACTIONAL_PROTOCOLE_REDACTION",
                      },
                    },
                    "Attente de réponse": {
                      on: {
                        "Paiement reçu": {
                          target:
                            "#Indemnisation.La compagnie accepte de payer.Attente du paiement sur le fond CARPA",
                          meta: {
                            EVENT_NAME:
                              "WAITING_FOR_MONEY.CONCILIATION_TRANSACTIONAL_PROTOCOL_PAID_AFTER_FOLLOW_UP",
                          },
                        },
                        "Absence de paiement > 40j": {
                          target:
                            "#Indemnisation.La compagnie accepte de payer.Procédure de paiement pré-contentieuse.Homologation protocole transactionnel",
                          meta: {
                            EVENT_NAME:
                              "WAITING_FOR_MONEY.CONCILIATION_TRANSACTIONAL_PROTOCOL_NOT_PAID_AFTER_FOLLOW_UP",
                          },
                        },
                      },
                      meta: {
                        EXPECTED_DURATION_IN_DAYS: 40,
                        STATE_NAME: "WAITING_FOR_MONEY.CONCILIATION_WAIT_FOR_TRANSACTIONAL_PROTOCOLE_REPLY",
                      },
                    },
                  },
                },
              },
            },
            "Procédure de paiement pré-contentieux après assignation": {
              initial: "Attente signature protocole transactionnel",
              states: {
                "Attente signature protocole transactionnel": {
                  on: {
                    "Envoi du protocole à la compagnie": {
                      target: "Attente réponse de la compagnie",
                      meta: {
                        EVENT_NAME: "WAITING_FOR_MONEY.COURT_TRANSACTIONAL_PROTOCOL_SENT_TO_AIRLINE",
                      },
                    },
                  },
                  entry: {
                    type: "Protocole transactionnel généré",
                  },
                  meta: {
                    EXPECTED_DURATION_IN_DAYS: 10,
                    STATE_NAME: "WAITING_FOR_MONEY.WAITING_FOR_TRANSACTIONAL_PROTOCOL",
                  },
                },
                "Attente réponse de la compagnie": {
                  on: {
                    "Signature du protocole par la compagnie": {
                      target:
                        "#Indemnisation.La compagnie accepte de payer.Attente du paiement sur le fond CARPA",
                      meta: {
                        EVENT_NAME: "WAITING_FOR_MONEY.COURT_TRANSACTIONAL_PROTOCOL_SIGNED_BY_AIRLINE",
                      },
                    },
                    "Protocole non signé par la compagnie": {
                      target: "#Indemnisation.Contentieux.Choix de la procédure",
                      meta: {
                        EVENT_NAME: "WAITING_FOR_MONEY.COURT_TRANSACTIONAL_PROTOCOL_NOT_SIGNED_BY_AIRLINE",
                      },
                    },
                  },
                  meta: {
                    EXPECTED_DURATION_IN_DAYS: 15,
                    STATE_NAME: "WAITING_FOR_MONEY.WAITING_FOR_TRANSACTIONAL_PROTOCOL_SIGNATURE",
                  },
                },
              },
            },
            "Homologation protocole transactionnel": {
              initial: "Attente Transmission au juge",
              states: {
                "Attente Transmission au juge": {
                  on: {
                    "Accord transactionnel homologué par le tribunal": {
                      target: "Attente Exécution forcée",
                      meta: {
                        EVENT_NAME: "WAITING_FOR_MONEY.COURT_TRANSACTIONAL_PROTOCOL_HOMOLOGATED_BY_COURT",
                      },
                    },
                  },
                  meta: {
                    EXPECTED_DURATION_IN_DAYS: 4,
                    STATE_NAME: "WAITING_FOR_MONEY.COURT_WAIT_FOR_TRANSACTIONAL_PROTOCOL_SEND_TO_COURT",
                  },
                },
                "Attente Exécution forcée": {
                  on: {
                    "Saisie de l'huissier": {
                      target:
                        "#Indemnisation.La compagnie accepte de payer.Attente du désistement d'instance et d'action",
                      actions: assign({ LEGAL_STEP: "BAILIFF" }),
                      meta: {
                        EVENT_NAME: "WAITING_FOR_MONEY.BAILIFF_SEIZED_AFTER_PROTOCOL_HOMOLOGATED_BY_COURT",
                      },
                    },
                  },
                  meta: {
                    EXPECTED_DURATION_IN_DAYS: 40,
                    STATE_NAME: "WAITING_FOR_MONEY.COURT_WAIT_FOR_FORCED_EXECUTION",
                  },
                },
              },
            },
          },
        },
        "Attente du paiement sur le fond CARPA": {
          on: {
            "Paiement reçu": {
              target: "Attente du désistement d'instance et d'action",
              meta: {
                EVENT_NAME: "WAITING_FOR_MONEY.COURT_DESISTEMENT_INSTANCE_ACTION_PAYMENT_RECEIVED",
              },
            },
            "Absence de paiement > 40j": {
              target:
                "#Indemnisation.La compagnie accepte de payer.Procédure de paiement pré-contentieuse.Procédure de relance pré-contentieux.Rédaction de relance avec protocole transactionnel",
              meta: {
                EVENT_NAME: "WAITING_FOR_MONEY.COURT_DESISTEMENT_INSTANCE_ACTION_PAYMENT_EXCEEDED_DELAY",
              },
            },
          },
          meta: {
            EXPECTED_DURATION_IN_DAYS: "40",
            STATE_NAME: "WAITING_FOR_MONEY.WAIT_FOR_CARPA_PAYMENT",
          },
        },
        "Attente du désistement d'instance et d'action": {
          on: {
            "Désistement d'instance et d'action": {
              target: "Claim gagnée",
              meta: {
                EVENT_NAME: "WAITING_FOR_MONEY.COURT_DESISTEMENT_INSTANCE_ACTION",
              },
            },
          },
          meta: {
            EXPECTED_DURATION_IN_DAYS: 3,
            STATE_NAME: "WAITING_FOR_MONEY.WAIT_FOR_COURT_DESISTEMENT_INSTANCE_ACTION",
          },
        },
        "Procédure de paiement après délibéré": {
          initial: "Attente de l'appel",
          meta: {
            EXPECTED_DURATION_IN_DAYS: "90",
          },
          states: {
            "Attente de l'appel": {
              on: {
                "Appel par la compagnie": {
                  target: "Procédure d'appel",
                  meta: {
                    EVENT_NAME: "COURT.AIRLINE_APPEAL",
                  },
                },
                "La compagnie n'a pas fait appel": {
                  target: "Attente du paiement sur fonds CARPA",
                  meta: {
                    EVENT_NAME: "COURT.NO_AIRLINE_APPEAL",
                  },
                },
              },
              meta: {
                EXPECTED_DURATION_IN_DAYS: 7,
                STATE_NAME: "COURT.WAIT_FOR_APPEAL",
              },
            },
            "Procédure d'appel": {
              on: {
                "Victoire appel": {
                  target: "#Indemnisation.La compagnie accepte de payer.Claim gagnée",
                  meta: {
                    EVENT_NAME: "COURT.VICTORY_AFTER_AIRLINE_APPEAL",
                  },
                },
                "Défaite appel": {
                  target: "#Indemnisation.Dossier perdu",
                  meta: {
                    EVENT_NAME: "COURT.LOST_AFTER_AIRLINE_APPEAL",
                  },
                },
              },
              description: "À faire",
              meta: {
                STATE_NAME: "COURT.WAIT_FOR_APPEAL_PROCEDURE",
                EXPECTED_DURATION_IN_DAYS: 400,
              },
            },
            "Attente du paiement sur fonds CARPA": {
              on: {
                "Paiement reçu": {
                  target: "#Indemnisation.La compagnie accepte de payer.Claim gagnée",
                  meta: {
                    EVENT_NAME: "COURT.AFTER_TRIAL_PAIEMENT_RECEIVED",
                  },
                },
                "Absence de paiement > 40j": {
                  target: "Procédure de relance après délibéré",
                  meta: {
                    EVENT_NAME: "COURT.AFTER_TRIAL_PAYMENT_EXCEED_DELAY",
                  },
                },
              },
              meta: {
                EXPECTED_DURATION_IN_DAYS: "40",
                STATE_NAME: "COURT.WAIT_FOR_PAYMENT_AFTER_TRIAL_VICTORY",
              },
            },
            "Procédure de relance après délibéré": {
              initial: "Attente saisie huissier",
              entry: {
                type: "Relance après délibéré ",
              },
              states: {
                "Attente saisie huissier": {
                  on: {
                    "Saisie de l'huissier": {
                      target: "Attente de l'huissier",
                      actions: assign({ LEGAL_STEP: "BAILIFF" }),
                      meta: {
                        EVENT_NAME: "BAILIFF.AFTER_TRIAL",
                      },
                    },
                    "Paiement reçu": {
                      target: "#Indemnisation.La compagnie accepte de payer.Claim gagnée",
                      meta: {
                        EVENT_NAME: "BAILIFF.AFTER_TRIAL_PAYMENT_RECEIVED",
                      },
                    },
                  },
                  meta: {
                    EXPECTED_DURATION_IN_DAYS: "15",
                    STATE_NAME: "BAILIFF.WAIT_FOR_BAILIF_CLAIM",
                  },
                },
                "Attente de l'huissier": {
                  on: {
                    "Exécution forcée": {
                      target: "Attente réception des fonds",
                      meta: {
                        EVENT_NAME: "BAILIFF.FORCED_EXECUTION",
                      },
                    },
                  },
                  meta: {
                    EXPECTED_DURATION_IN_DAYS: 10,
                    STATE_NAME: "BAILIFF.WAIT_FOR_BAILIF_REPLY",
                  },
                },
                "Attente réception des fonds": {
                  on: {
                    "Paiement reçu": {
                      target: "#Indemnisation.La compagnie accepte de payer.Claim gagnée",
                      meta: {
                        EVENT_NAME: "BAILIFF.PAYMENT_RECEIVED",
                      },
                    },
                  },
                  meta: {
                    EXPECTED_DURATION_IN_DAYS: 30,
                    STATE_NAME: "BAILIFF.WAIT_FOR_PAYMENT_AFTER_REQUISITION",
                  },
                },
              },
            },
          },
        },
        "Paiement effectué": {
          type: "final",
          description: "Les indemnités vous seront transférées d'ici (15) quinze jours.",
          meta: {
            STATE_NAME: "PAYMENT_SENT",
            "@statelyai.color": "green",
          },
        },
        "Procédure de paiement - MTV": {
          initial: "Attente du paiement suite médiation",
          meta: {
            EXPECTED_DURATION_IN_DAYS: "30",
            "@statelyai.color": "orange",
          },
          states: {
            "Attente du paiement suite médiation": {
              on: {
                "Réponse favorable": {
                  target: "Attente reception des fonds sur compte",
                  meta: {
                    EVENT_NAME: "WAITING_FOR_MONEY.MEDIATION_FOLLOW_UP_AIRLINE_AGREEMENT",
                  },
                },
                "Attente > 30J": {
                  target: "#Indemnisation.Contentieux.Choix de la procédure",
                  meta: {
                    EVENT_NAME: "WAITING_FOR_MONEY.MEDIATION_PAYMENT_NOT_RECEIVED",
                  },
                },
              },
              meta: {
                EXPECTED_DURATION_IN_DAYS: 30,
                STATE_NAME: "WAITING_FOR_MONEY.MEDIATION_WAIT_FOR_PAYMENT",
              },
            },
            "Attente reception des fonds sur compte": {
              on: {
                "Absence de paiement > 40j": {
                  target: "#Indemnisation.Contentieux.Choix de la procédure.Attente choix de la compétence",
                  meta: {
                    EVENT_NAME: "WAITING_FOR_MONEY.MEDIATION_PAYMENT_NOT_RECEIVED_AFTER_FOLLOW_UP",
                  },
                },
                "Paiement reçu": {
                  target: "#Indemnisation.La compagnie accepte de payer.Claim gagnée",
                  meta: {
                    EVENT_NAME: "WAITING_FOR_MONEY.MEDIATION_PAYMENT_RECEIVED_AFTER_FOLLOW_UP",
                  },
                },
              },
              meta: {
                EXPECTED_DURATION_IN_DAYS: 30,
                STATE_NAME: "WAITING_FOR_MONEY.MEDIATION_WAIT_FOR_PAYMENT_AFTER_FOLLOW_UP",
              },
            },
          },
        },
      },
    },
    Contentieux: {
      initial: "Choix de la procédure",
      entry: assign({ LEGAL_STEP: "COURT" }),
      meta: {
        EXPECTED_DURATION_IN_DAYS: 190,
        "@statelyai.color": "red",
      },
      states: {
        "Choix de la procédure": {
          initial: "Attente choix de la compétence",
          on: {
            Abandon: {
              target: "#Indemnisation.Dossier perdu",
              meta: {
                EVENT_NAME: "COURT.PROCEDURE_CHOICE_ABORTION",
              },
            },
            "Envoi au Médiateur": {
              target: "Médiation Tourisme",
              description:
                "Suite du décret du 5 août 2025 <https://www.legifrance.gouv.fr/jorf/id/JORFTEXT000052052454>",
              meta: {
                EVENT_NAME: "COURT.MEDIATION_PROCEDURE",
                EXPECTED_DURATION_IN_DAYS: 15,
              },
            },
          },
          meta: {
            EXPECTED_DURATION_IN_DAYS: "2",
          },
          states: {
            "Attente choix de la compétence": {
              on: {
                "Tribunal compétent sélectionné": {
                  target: "Attente choix de la procédure",
                  meta: {
                    EVENT_NAME: "COURT.JURIDCTION_CHOOSEN",
                  },
                },
              },
              meta: {
                EXPECTED_DURATION_IN_DAYS: 5,
                STATE_NAME: "COURT.WAIT_FOR_JURIDCTION_CHOICE",
              },
            },
            "Attente choix de la procédure": {
              on: {
                "Règlement des petits litiges européens": {
                  target: "#Indemnisation.Contentieux.Règlement des petits litiges européens",
                  description: "- Compagnie non Française\n- Montant < 5000€",
                  meta: {
                    EVENT_NAME: "COURT.PROCEDURE_REPL",
                  },
                },
                "Procédure classique": {
                  target: "#Indemnisation.Contentieux.Procédure classique",
                  meta: {
                    EVENT_NAME: "COURT.PROCEDURE_CLASSIQUE",
                  },
                },
                "Procédure bref délai": {
                  target: "#Indemnisation.Contentieux.Procédure bref délai",
                  meta: {
                    EVENT_NAME: "COURT.PROCEDURE_BREF_DELAI",
                  },
                },
              },
              meta: {
                EXPECTED_DURATION_IN_DAYS: 2,
                STATE_NAME: "COURT.WAIT_FOR_PROCEDURE_CHOICE",
              },
            },
          },
        },
        "Médiation Tourisme": {
          initial: "Attente retour du Médiateur",
          on: {
            "Désistement médiateur suite à accord avec la compagnie": {
              target:
                "#Indemnisation.La compagnie accepte de payer.Procédure de paiement - MTV.Attente reception des fonds sur compte",
              meta: {
                EVENT_NAME: "COURT.MEDIATION_AIRLINE_AGREE_TO_PAY_DURING_PROCEDURE",
              },
            },
            Abandon: {
              target: "#Indemnisation.Abandon",
              meta: {
                EVENT_NAME: "COURT.MEDIATION_ABANDON_CLAIM",
              },
            },
          },
          meta: {
            "@statelyai.color": "yellow",
          },
          states: {
            "Attente retour du Médiateur": {
              on: {
                "Le médiateur s'est saisi du dossier": {
                  target: "Attente avis du médiateur",
                  description:
                    "Il dispose de 90 jours rendre son avis. D'après les statistiques officielles du MTV, l'avis est ensuite accepté dans 92% des cas par les compagnies aériennes (chiffres 2024).",
                  meta: {
                    EVENT_NAME: "COURT.MEDIATION_PROCEDURE_VALIDATED",
                    EXPECTED_DURATION_IN_DAYS: 100,
                  },
                },
                "Le médiateur rejette le traitement du dossier": {
                  target: "#Indemnisation.Contentieux.Choix de la procédure.Attente choix de la compétence",
                  meta: {
                    EVENT_NAME: "COURT.MEDIATION_PROCEDURE_REJECTED",
                  },
                },
              },
              meta: {
                STATE_NAME: "COURT.WAIT_FOR_MEDIATION_VALIDATION",
                EXPECTED_DURATION_IN_DAYS: 21,
              },
            },
            "Attente avis du médiateur": {
              on: {
                "Avis négatif : Rejet de l'avis par le médiateur": {
                  target: "#Indemnisation.Contentieux.Choix de la procédure.Attente choix de la compétence",
                  description: "Envoi aux avocat pour enrôlement au tribunal",
                  meta: {
                    EVENT_NAME: "COURT.MEDIATION_PROCEDURE_LOST",
                  },
                },
                "Avis favorable du Médiateur": {
                  target: "Attente réaction compagnie aérienne",
                  meta: {
                    EVENT_NAME: "COURT.MEDIATION_PROCEDURE_WON",
                  },
                },
                "Absence d'avis après 6 mois": {
                  target: "#Indemnisation.Contentieux.Choix de la procédure",
                  meta: {
                    EVENT_NAME: "COURT.MEDIATION_EXPIRED_AFTER_SIX_MONTH",
                  },
                },
              },
              meta: {
                STATE_NAME: "COURT.WAIT_FOR_MEDIATION_DECISION",
                EXPECTED_DURATION_IN_DAYS: 180,
              },
            },
            "Attente réaction compagnie aérienne": {
              on: {
                "La compagnie annonce suivre l'avis du médiateur": {
                  target:
                    "#Indemnisation.La compagnie accepte de payer.Procédure de paiement - MTV.Attente du paiement suite médiation",
                  meta: {
                    EVENT_NAME: "COURT.MEDIATION_AIRLINE_ACCEPT_AVIS",
                  },
                },
                "Rejet de l'avis par la compagnie aérienne": {
                  target: "#Indemnisation.Contentieux.Choix de la procédure",
                  meta: {
                    EVENT_NAME: "COURT.MEDIATION_AVIS_REJECTED_BY_AIRLINE",
                  },
                },
                "La compagnie n'a pas répondu": {
                  target: "#Indemnisation.Contentieux.Choix de la procédure",
                  meta: {
                    EVENT_NAME: "COURT.MEDIATION_AVIS_AIRLINE_EXPIRED_RESPONSE",
                  },
                },
              },
              meta: {
                STATE_NAME: "COURT.AWATING_AIRLINE_REACTION_AFTER_MEDIATION_DECISION",
                EXPECTED_DURATION_IN_DAYS: 30,
              },
            },
          },
        },
        "Procédure classique": {
          initial: "Procédure déverouillée",
          on: {
            "Accord trouvé": {
              target:
                "#Indemnisation.La compagnie accepte de payer.Procédure de paiement pré-contentieuse.Procédure de paiement pré-contentieux avant assignation",
              meta: {
                EVENT_NAME: "COURT.PROCEDURE_CLASSIQUE_UNLOCKED_AGREEMENT",
              },
            },
          },
          entry: {
            type: "Assignation",
          },
          description: "L'assignation est générée",
          states: {
            "Procédure déverouillée": {
              initial: "Attente choix de la date d'audience",
              on: {
                "Retour au choix de la procédure": {
                  target: "#Indemnisation.Contentieux.Choix de la procédure",
                  meta: {
                    EVENT_NAME: "COURT.BACK_TO_PROCEDURE_SELECTION",
                  },
                },
                "Retour au choix de Tribunal": {
                  target: "#Indemnisation.Contentieux.Choix de la procédure.Attente choix de la compétence",
                  meta: {
                    EVENT_NAME: "COURT.PROCEDURE_CLASSIQUE_BACK_JURIDICTION_SELECTED",
                  },
                },
                "Abandon de la procédure": {
                  target: "#Indemnisation.Dossier perdu",
                  meta: {
                    EVENT_NAME: "COURT.PROCEDURE_CLASSIQUE_UNLOCKED_ABORTION",
                  },
                },
              },
              states: {
                "Attente choix de la date d'audience": {
                  on: {
                    "Date d'audience sélectionnée": {
                      target: "SAS de date d'audience",
                      meta: {
                        EVENT_NAME: "COURT.PROCEDURE_CLASSIQUE_DATE_SELECTED_TRIAL",
                      },
                    },
                  },
                  description: "On attend au moins 5 dossiers",
                  meta: {
                    EXPECTED_DURATION_IN_DAYS: 3,
                    STATE_NAME: "COURT.PROCEDURE_CLASSIQUE_WAIT_FOR_TRIAL_DATE_CHOICE",
                  },
                },
                "SAS de date d'audience": {
                  initial: "Attente pour obtenir un groupe",
                  states: {
                    "Attente pour obtenir un groupe": {
                      on: {
                        "Groupe validé": {
                          target:
                            "#Indemnisation.Contentieux.Procédure classique.Procédure déverouillée.Attente assignation (générée)",
                          meta: {
                            EVENT_NAME: "COURT.PROCEDURE_CLASSIQUE_GROUP_CONFIRM_SAS_TRIAL_DATE",
                          },
                        },
                        "Retour au choix de la date d'audience": {
                          target:
                            "#Indemnisation.Contentieux.Procédure classique.Procédure déverouillée.Attente choix de la date d'audience",
                          meta: {
                            EVENT_NAME: "COURT.PROCEDURE_CLASSIQUE_BACK_TRIAL_DATE_SELECTED",
                          },
                        },
                      },
                      meta: {
                        EXPECTED_DURATION_IN_DAYS: 10,
                        STATE_NAME: "COURT.PROCEDURE_CLASSIQUE_WAIT_FOR_GROUP",
                      },
                    },
                  },
                },
                "Attente assignation (générée)": {
                  on: {
                    "Assignation validée": {
                      target: "Attente de transmission à l'huissier",
                      description: "Assignation validée par l'avocat en charge du dossier",
                      meta: {
                        EVENT_NAME: "COURT.PROCEDURE_CLASSIQUE_ASSIGNATION_CONFIRM_LAWYER",
                      },
                    },
                  },
                  meta: {
                    EXPECTED_DURATION_IN_DAYS: 3,
                    STATE_NAME: "COURT.PROCEDURE_CLASSIQUE_WAIT_FOR_ASSIGNATION_GENERATION",
                  },
                },
                "Attente de transmission à l'huissier": {
                  on: {
                    "Assignation transmise à l'huissier": {
                      target:
                        "#Indemnisation.Contentieux.Procédure classique.Procédure verrouillée.Attente retour des assignations",
                      meta: {
                        EVENT_NAME: "COURT.PROCEDURE_CLASSIQUE_SEND_ASSIGNATION_BAILIFF",
                      },
                    },
                  },
                  meta: {
                    EXPECTED_DURATION_IN_DAYS: 2,
                    STATE_NAME: "COURT.PROCEDURE_CLASSIQUE_WAIT_FOR_BAILLIF_TRANSMISSION",
                  },
                },
              },
            },
            "Procédure verrouillée": {
              initial: "Attente retour des assignations",
              on: {
                "Désistement d'instance simple": {
                  target: "#Indemnisation.Attente choix destinée du dossier",
                  meta: {
                    EVENT_NAME: "COURT.PROCEDURE_CLASSIQUE_SIMPLE_WITHDRAWAL",
                  },
                },
              },
              states: {
                "Attente retour des assignations": {
                  on: {
                    "Accord trouvé": {
                      target:
                        "#Indemnisation.La compagnie accepte de payer.Procédure de paiement pré-contentieuse.Procédure de paiement pré-contentieux après assignation",
                      meta: {
                        EVENT_NAME: "COURT.PROCEDURE_CLASSIQUE_AGREEMENT_LOCKED",
                      },
                    },
                    "L'huissier a remis l'assignation à la compagnie aérienne": {
                      target: "Attente enrôlement",
                      meta: {
                        EVENT_NAME: "COURT.ASSIGNATION_COPY_REVEIVED",
                      },
                    },
                  },
                  meta: {
                    EXPECTED_DURATION_IN_DAYS: 7,
                    STATE_NAME: "COURT.PROCEDURE_CLASSIQUE_WAIT_FOR_BAILLIF_UPLOAD",
                  },
                },
                "Attente enrôlement": {
                  on: {
                    "Dossier enrôlé auprès du tribunal": {
                      target: "Attente audience de mise en état",
                      meta: {
                        EVENT_NAME: "COURT.CLAIM_ENLISTMENT",
                      },
                    },
                  },
                  meta: {
                    EXPECTED_DURATION_IN_DAYS: 7,
                    STATE_NAME: "COURT.PROCEDURE_CLASSIQUE_WAIT_FOR_ENROLMENT",
                  },
                },
                "Attente audience de mise en état": {
                  on: {
                    "Absence d'accord avant l'audience": {
                      target: "Attente audience de plaidoirie",
                      description: "Communication du calendrier pour le tribunal",
                      meta: {
                        EVENT_NAME: "COURT.PROCEDURE_CLASSIQUE_NO_AGREEMENT_WITH_AIRLINE",
                      },
                    },
                  },
                  entry: {
                    type: "Rédaction des conclusions",
                  },
                  meta: {
                    EXPECTED_DURATION_IN_DAYS: 60,
                    STATE_NAME: "COURT.PROCEDURE_CLASSIQUE_WAIT_FOR_CALENDAR_HEARING",
                  },
                },
                "Attente audience de plaidoirie": {
                  on: {
                    "Audience de plaidoirie effectuée": {
                      target: "Attente du résultat du délibéré",
                      description:
                        "L'audience de plaidoirie a eu lieu devant le juge chargé d'instruire l'affaire.",
                      meta: {
                        EVENT_NAME: "COURT.PROCEDURE_CLASSIQUE_TRIAL",
                      },
                    },
                    Renvoi: {
                      target: "Attente audience de plaidoirie",
                      meta: {
                        EVENT_NAME: "COURT.PROCEDURE_CLASSIQUE_TRIAL_REFERRAL",
                      },
                      reenter: true,
                    },
                  },
                  entry: {
                    type: "Envoi du jeu de conclusion",
                  },
                  meta: {
                    EXPECTED_DURATION_IN_DAYS: 60,
                    STATE_NAME: "COURT.PROCEDURE_CLASSIQUE_WAIT_FOR_HEARING",
                  },
                },
                "Attente du résultat du délibéré": {
                  on: {
                    "Victoire du procès": {
                      target: "Attente signification de jugement",
                      meta: {
                        EVENT_NAME: "COURT.PROCEDURE_CLASSIQUE_TRIAL_WON",
                      },
                    },
                    "Défaite procès": {
                      target: "#Indemnisation.Attente choix destinée du dossier",
                      meta: {
                        EVENT_NAME: "COURT.PROCEDURE_CLASSIQUE_TRIAL_LOST",
                      },
                    },
                  },
                  meta: {
                    EXPECTED_DURATION_IN_DAYS: 25,
                    STATE_NAME: "COURT.PROCEDURE_CLASSIQUE_WAIT_FOR_DELIBERATE_RESULTS",
                  },
                },
                "Attente signification de jugement": {
                  on: {
                    "Décision signifiée": {
                      target:
                        "#Indemnisation.La compagnie accepte de payer.Procédure de paiement après délibéré",
                      meta: {
                        EVENT_NAME: "COURT.PROCEDURE_CLASSIQUE_TRIAL_NOTIFIED_DECISION",
                      },
                    },
                  },
                  meta: {
                    EXPECTED_DURATION_IN_DAYS: 15,
                    STATE_NAME: "COURT.PROCEDURE_CLASSIQUE_WAIT_TRIAL_SIGNIFICATION",
                  },
                },
              },
            },
          },
        },
        "Procédure bref délai": {
          initial: "Attente date rendez-vous préalable avec le Président",
          entry: {
            type: 'Mail au greffe du TC pour solliciter une procédure "Bref délai"',
          },
          states: {
            "Attente date rendez-vous préalable avec le Président": {
              on: {
                "Conclusion vérifiée": {
                  target: "Attente date rendez-vous préalable avec le Président",
                  meta: {
                    EVENT_NAME: "COURT.BREF_DELAI_CHECK_CONCLUSIONS",
                  },
                  reenter: true,
                },
                "Date communiquée": {
                  target: "Attente rendez-vous préalable",
                  actions: {
                    type: "Requête envoyée ",
                  },
                  meta: {
                    EVENT_NAME: "COURT.BREF_DELAI_DATE_RECEIVED",
                  },
                },
              },
              entry: {
                type: "Rédaction de la requête",
              },
              meta: {
                EXPECTED_DURATION_IN_DAYS: 60,
                STATE_NAME: "COURT.BREF_DELAI_WAIT_FOR_PRESIDENT_APPOINTMENT_REPLY",
              },
            },
            "Attente rendez-vous préalable": {
              on: {
                "Procédure bref délai accordée": {
                  target:
                    "#Indemnisation.Contentieux.Procédure classique.Procédure verrouillée.Attente audience de plaidoirie",
                  actions: {
                    type: 'Envoi de l\'assignation + ordonnance "bref délai"',
                  },
                  meta: {
                    EVENT_NAME: "COURT.BREF_DELAI_GRANTED",
                  },
                },
                "Procédure bref délai refusée": {
                  target: "#Indemnisation.Contentieux.Procédure classique",
                  meta: {
                    EVENT_NAME: "COURT.BREF_DELAI_REJECTED",
                  },
                },
              },
              meta: {
                EXPECTED_DURATION_IN_DAYS: 90,
                STATE_NAME: "COURT.BREF_DELAI_WAIT_FOR_PRESIDENT_APPOINTMENT_DATE",
              },
            },
          },
        },
        "Règlement des petits litiges européens": {
          initial: "Attente phase formulaire A",
          entry: {
            type: "Remplissage formulaire A",
          },
          states: {
            "Attente phase formulaire A": {
              on: {
                "Formulaire prêt pour envoi sans plaidoirie": {
                  target: "Attente envoi du formulaire A",
                  meta: {
                    EVENT_NAME: "COURT.ESCP_FORM_A_CHECK_NO_PLEAD",
                  },
                },
                "Formulaire prêt pour envoi avec plaidoirie": {
                  target: "SAS de groupement",
                  meta: {
                    EVENT_NAME: "COURT.ESCP_FORM_A_CHECK_PLEAD",
                  },
                },
              },
              meta: {
                EXPECTED_DURATION_IN_DAYS: 3,
                STATE_NAME: "COURT.WAIT_FOR_ESCP_FORM_A",
              },
            },
            "Attente envoi du formulaire A": {
              on: {
                "Formulaire A envoyé": {
                  target: "Attente reception par le tribunal",
                  meta: {
                    EVENT_NAME: "COURT.ESCP_FORM_A_SENT",
                  },
                },
              },
              meta: {
                EXPECTED_DURATION_IN_DAYS: 3,
                STATE_NAME: "COURT.WAIT_FOR_ESCP_FORM_A_SEND",
              },
            },
            "SAS de groupement": {
              initial: "Attente obtention du groupe",
              states: {
                "Attente obtention du groupe": {
                  on: {
                    "Validation du groupe": {
                      target:
                        "#Indemnisation.Contentieux.Règlement des petits litiges européens.Attente envoi du formulaire A",
                      meta: {
                        EVENT_NAME: "COURT.ESCP_GROUP_CONFIRM_SAS_TRIAL_DATE",
                      },
                    },
                    "Retour au choix du tribunal": {
                      target:
                        "#Indemnisation.Contentieux.Choix de la procédure.Attente choix de la compétence",
                      meta: {
                        EVENT_NAME: "COURT.ESCP_BACK_CHOSSEN_TRIAL",
                      },
                    },
                  },
                  meta: {
                    EXPECTED_DURATION_IN_DAYS: 7,
                    STATE_NAME: "COURT.WAIT_FOR_ESCP_GROUP",
                  },
                },
              },
            },
            "Attente reception par le tribunal": {
              on: {
                "Formulaire C envoyé par le tribunal": {
                  target: "Attente réponse par la compagnie (Formulaire C)",
                  meta: {
                    EXPECTED_DURATION_IN_DAYS: 14,
                    EVENT_NAME: "COURT.REPL_FORM_C_RECEIVED_COURT",
                  },
                },
                "Formulaire B reçu (demande complémentaire)": {
                  target: "Réponse formulaire B",
                  meta: {
                    EVENT_NAME: "COURT.ESPC_FORM_B_RECEIVED",
                  },
                },
              },
              description:
                "Obligation d'accusé reception du formulaire et d'envoyer le C en 14 jours maximum",
              meta: {
                EXPECTED_DURATION_IN_DAYS: 15,
                STATE_NAME: "COURT.WAIT_FOR_ESCP_FORM_A_COURT_RECEIPT",
              },
            },
            "Attente réponse par la compagnie (Formulaire C)": {
              on: {
                "Réponse de la compagnie": {
                  target: "En attente de réponse de notre part",
                  meta: {
                    EVENT_NAME: "COURT.REPL_WAITING_FOR_AIRLINE_REPLY_1",
                  },
                },
                "Absence de réponse > 30j (Sans plaidoirie)": {
                  target:
                    "#Indemnisation.Contentieux.Procédure classique.Procédure verrouillée.Attente du résultat du délibéré",
                  description: "L'audience doit intervenir sous 30 jours",
                  meta: {
                    EXPECTED_DURATION_IN_DAYS: 30,
                    EVENT_NAME: "COURT.REPL_AIRLINE_REPLY_DELAY_EXCEDEED",
                  },
                },
                "Absence de réponse > 30j (Avec plaidoirie)": {
                  target:
                    "#Indemnisation.Contentieux.Procédure classique.Procédure verrouillée.Attente audience de plaidoirie",
                  meta: {
                    EVENT_NAME: "COURT.REPL_AIRLINE_REPLY_DELAY_EXCEDEED_WITH_PLEADING",
                  },
                },
              },
              description: "La compagnie à 30 jours pour répondre par le Formulaire C",
              meta: {
                EXPECTED_DURATION_IN_DAYS: "30",
                STATE_NAME: "COURT.WAIT_FOR_ESCP_FORM_C_AIRLINE_REPLY",
              },
            },
            "Réponse formulaire B": {
              on: {
                "Formulaire B envoyé au tribunal": {
                  target: "Attente reception par le tribunal",
                  meta: {
                    EVENT_NAME: "COURT.ESCP_FORM_B_COURT_SENT",
                  },
                },
              },
              meta: {
                EXPECTED_DURATION_IN_DAYS: 20,
                STATE_NAME: "COURT.WAIT_FOR_ESCP_FORM_B",
              },
            },
            "En attente de réponse de notre part": {
              on: {
                "Abandon car nous sommes d'accord avec les arguments de la compagnie": {
                  target: "#Indemnisation.Attente choix destinée du dossier",
                  meta: {
                    EVENT_NAME: "COURT.REPL_ABORTION",
                  },
                },
                "Droit de réponse exercé (Sans plaidoirie)": {
                  target:
                    "#Indemnisation.Contentieux.Procédure classique.Procédure verrouillée.Attente du résultat du délibéré",
                  description: "Délai rallongé de 14 jours",
                  meta: {
                    EVENT_NAME: "COURT.REPL_AIRLINE_RIGHT_OF_REPLY_EXTENDED_EXERCISED",
                  },
                },
                "Droit de réponse exercé (Avec plaidoirie)": {
                  target:
                    "#Indemnisation.Contentieux.Procédure classique.Procédure verrouillée.Attente audience de plaidoirie",
                  description: "Délai rallongé de 14 jours",
                  meta: {
                    EVENT_NAME: "COURT.REPL_AIRLINE_RIGHT_OF_REPLY_EXTENDED_EXERCISED_WITH_PLEADING",
                  },
                },
              },
              meta: {
                EXPECTED_DURATION_IN_DAYS: "7",
                STATE_NAME: "COURT.WAIT_FOR_ESCP_FORM_C_UPCLAIM_REPLY",
              },
            },
          },
        },
      },
    },
    "Dossier perdu": {
      type: "final",
      entry: assign({ LEGAL_STEP: "CANCELLED" }),
      description: "Échec de recouvrement de la créance",
      meta: {
        STATE_NAME: "LOST",
      },
    },
    "Attente choix destinée du dossier": {
      on: {
        "Dossier abandonné": {
          target: "Dossier perdu",
          meta: {
            EVENT_NAME: "COURT.PROCEDURE_CLASSIQUE_LOCKED_ABORTION",
          },
        },
        "Retour au choix du tribunal": {
          target: "#Indemnisation.Contentieux.Choix de la procédure.Attente choix de la compétence",
          meta: {
            EVENT_NAME: "COURT.PROCEDURE_CLASSIQUE_LOCKED_BACK_COURT_CHOSEN",
          },
        },
      },
      meta: {
        EXPECTED_DURATION_IN_DAYS: 10,
        STATE_NAME: "COURT.WAIT_FOR_CLAIM_DESTINY",
      },
    },
  },
});
